var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"front"},[_vm._t("image"),_vm._t("front")],2),_c('div',{staticClass:"back"},[_vm._t("back")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }